import { render, staticRenderFns } from "./LinkedWebapps.vue?vue&type=template&id=134c2c98&"
import script from "./LinkedWebapps.vue?vue&type=script&lang=js&"
export * from "./LinkedWebapps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports